import { IcZoomMinus, IcZoomPlus } from '@assets/icons/24x24';
import {
  Box,
  Center,
  Icon,
  IconButton,
  SliderValueChangeDetails,
  StackSeparator,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useMapContext } from '@components/map/MapContext';
import { Slider } from '@components/ui/slider';

function ZoomControl() {
  const { map, viewState, setZoom } = useMapContext();
  const zoom = viewState.zoom;

  return (
    <Box position="relative" marginTop="auto" userSelect="none">
      <Center
        flexDirection="column"
        width="72px"
        height="212px"
        backgroundColor="neutral.900"
        border="2px solid"
        borderColor="neutral.800"
        gap={1}
      >
        <Slider
          height="144px"
          min={0}
          max={22}
          orientation="vertical"
          value={[zoom]}
          delay={0}
          onValueChange={(newZoom: SliderValueChangeDetails) => setZoom(newZoom.value.at(0)!)}
        />
        <Text color="neutral.300">{`${Math.round((zoom / 22) * 100)}%`}</Text>
      </Center>
      <VStack
        position="absolute"
        top="calc(50% - 62px)"
        right="72px"
        height="126px"
        width="46px"
        backgroundColor="neutral.900"
        clipPath="polygon(100% 98.33%, 5.02% 78.81%, 5.02% 21.18%, 100% 1.67%)"
        padding="2px"
        paddingRight={0}
      >
        <VStack
          backgroundColor="neutral.900"
          height="100%"
          width="100%"
          gap={0}
          clipPath="polygon(100% 98.33%, 5.02% 78.81%, 5.02% 21.18%, 100% 1.67%)"
          overflow="hidden"
          separator={<StackSeparator border="2px solid" color="neutral.900" />}
        >
          <IconButton
            aria-label="Zoom in"
            flex={1}
            width="full"
            color="neutral.300"
            backgroundColor="neutral.800"
            borderRadius={0}
            border="none !important"
            boxShadow="none"
            _hover={{
              backgroundColor: 'neutral.600',
              color: 'neutral.200',
            }}
            _active={{
              backgroundColor: 'neutral.black',
              color: 'neutral.200',
            }}
            onClick={() => setZoom(Math.min(map?.getMaxZoom() ?? 22, zoom + 1))}
          >
            <Icon as={IcZoomPlus} boxSize="24px" marginTop="20px" />
          </IconButton>
          <IconButton
            aria-label="Zoom out"
            flex={1}
            width="full"
            color="neutral.300"
            backgroundColor="neutral.800"
            borderRadius={0}
            border="none !important"
            boxShadow="none"
            _hover={{
              backgroundColor: 'neutral.600',
              color: 'neutral.200',
            }}
            _active={{
              backgroundColor: 'neutral.black',
              color: 'neutral.200',
            }}
            onClick={() => setZoom(Math.max(map?.getMinZoom() ?? 0, zoom - 1))}
          >
            <Icon as={IcZoomMinus} boxSize="24px" marginBottom="20px" />
          </IconButton>
        </VStack>
      </VStack>
    </Box>
  );
}

export default ZoomControl;
